import { BaseAction } from './BaseAction';

export enum TagManagerActions {
  SendGTMEvent = '[Tag Manager] Send GTM Event',
}

export class SendGTMEvent implements BaseAction<TagManagerActions> {
  readonly type = TagManagerActions.SendGTMEvent;

  constructor(public readonly payload: any) {}
}

export type TagManagerAction = SendGTMEvent;
